import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSortDown as fadSortDown,
  faSortUp as fadSortUp,
  faSignal as fadSignal,
  faSignalWeak as fadSignalWeak,
  faSignalFair as fadSignalFair,
  faSignalGood as fadSignalGood,
  faSignalStrong as fadSignalStrong,
  faSignalPerfect as fadSignalPerfect
} from '@fortawesome/pro-duotone-svg-icons';
import {
  faNote as falNote,
  faAddressCard as falAddressCard,
  faApartment as falApartment,
  faArrowLeft as falArrowLeft,
  faArrowProgress as falArrowProgress,
  faBan as falBan,
  faBicycle as falBicycle,
  faBolt as falBolt,
  faBoltSlash as falBoltSlash,
  faBox as falBox,
  faBuilding as falBuilding,
  faBuildingColumns as falBuildingColumns,
  faBuildings as falBuildings,
  faCube as falCube,
  faCubes as falCubes,
  faBus as falBus,
  faCar as falCar,
  faCarSideBolt as falCarSideBolt,
  faCartShopping as falCartShopping,
  faChargingStation as falChargingStation,
  faCircleB as falCircleB,
  faCircleCheck as falCircleCheck,
  faCircleD as falCircleD,
  faCircleExclamation as falCircleExclamation,
  faCircleI as falCircleI,
  faCircleInfo as falCircleInfo,
  faCircleL as falCircleL,
  faCircleM as falCircleM,
  faCircleMinus as falCircleMinus,
  faCircleN as falCircleN,
  faCircleParking as falCircleParking,
  faCircleQuestion as falCircleQuestion,
  faCircleR as falCircleR,
  faCircleS as falCircleS,
  faCircleT as falCircleT,
  faCircleW as falCircleW,
  faCircleXmark as falCircleXmark,
  faCloud as falCloud,
  faEnvelope as falEnvelope,
  faEye as falEye,
  faEyeSlash as falEyeSlash,
  faEthernet as falEthernet,
  faFileInvoiceDollar as falFileInvoiceDollar,
  faFloppyDisk as falFloppyDisk,
  faForkKnife as falForkKnife,
  faFutbol as falFutbol,
  faGasPump as falGasPump,
  faGaugeHigh as falGaugeHigh,
  faGlobe as falGlobe,
  faHome as falHome,
  faHotel as falHotel,
  faHourglassEmpty as falHourglassEmpty,
  faIdCard as falIdCard,
  faListCheck as falListCheck,
  faLock as falLock,
  faMobileSignalOut as falMobileSignalOut,
  faMoneyBill1 as falMoneyBill1,
  faMugSaucer as falMugSaucer,
  faPlane as falPlane,
  faRacquet as falRacquet,
  faShareNodes as falShareNodes,
  faSignalStream as falSignalStream,
  faSimCard as falSimCard,
  faSitemap as falSitemap,
  faStairs as falStairs,
  faTaxi as falTaxi,
  faTrain as falTrain,
  faTrainSubwayTunnel as falTrainSubwayTunnel,
  faTrainTram as falTrainTram,
  faTree as falTree,
  faTrees as falTrees,
  faTriangleExclamation as falTriangleExclamation,
  faUser as falUser,
  faWifi as falWifi,
  faWrench as falWrench,
  faXmark as falXmark
} from '@fortawesome/pro-light-svg-icons';
import {
  faArrowDown,
  faArrowRightFromBracket,
  faArrowsRotate,
  faArrowUp,
  faArrowUpToLine,
  faChevronDown,
  faChevronsLeft,
  faChevronsRight,
  faChevronUp,
  faCircle,
  faCircleNotch,
  faClock,
  faCopy,
  faCube,
  faEllipsisVertical,
  faFileLines,
  faHashtag,
  faKey,
  faLocationDot,
  faPenToSquare,
  faPen,
  faSpinner,
  faTrash,
  faTrashCan,
  faTurnDownRight
} from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowDownWideShort as fasArrowDownWideShort,
  faArrowRight as fasArrowRight,
  faArrowRotateRight as fasArrowRotateRight,
  faArrowsRotate as fasArrowsRotate,
  faArrowUpArrowDown as fasArrowUpArrowDown,
  faBan as fasBan,
  faBars as fasBars,
  faBatteryBolt as fasBatteryBolt,
  faBoltLightning as fasBoltLightning,
  faCaretDown as fasCaretDown,
  faCaretUp as fasCaretUp,
  faChargingStation as fasChargingStation,
  faCheck as fasCheck,
  faCircleCheck as fasCircleCheck,
  faCircleExclamation as fasCircleExclamation,
  faCircleInfo as fasCircleInfo,
  faCircleSmall as fasCircleSmall,
  faCircleXmark as fasCircleXmark,
  faCodeSimple as fasCodeSimple,
  faDatabase as fasDatabase,
  faDoorOpen as fasDoorOpen,
  faFileCsv as fasFileCsv,
  faFingerprint as fasFingerprint,
  faForward as fasForward,
  faGaugeHigh as fasGaugeHigh,
  faGear as fasGear,
  faGlobe as fasGlobe,
  faHandshakeAlt as fasHandshakeAlt,
  faHandshakeAngle as fasHandshakeAngle,
  faHome as fasHome,
  faInfo as fasInfo,
  faLink as fasLink,
  faLocationDot as fasLocationDot,
  faMagnifyingGlass as fasMagnifyingGlass,
  faMailbox as fasMailbox,
  faMoneyBillTransfer as fasMoneyBillTransfer,
  faPercent as fasPercent,
  faPlay as fasPlay,
  faPlug as fasPlug,
  faPlus as fasPlus,
  faPowerOff as fasPowerOff,
  faRefresh as fasRefresh,
  faRepeat as fasRepeat,
  faReplyAll as fasReplyAll,
  faRotateRight as fasRotateRight,
  faScrewdriverWrench as fasScrewDriverWrench,
  faSendBack as fasSendBack,
  faShuffle as fasShuffle,
  faSignal as fasSignal,
  faSlidersSimple as fasSlidersSimple,
  faSolarPanel as fasSolarPanel,
  faSort as fasSort,
  faStop as fasStop,
  faTemperatureThreeQuarters as fasTemperatureThreeQuarters,
  faTimer as fasTimer,
  faTrash as fasTrash,
  faUnlock as fasUnlock,
  faUpload as fasUpload,
  faUser as fasUser,
  faUserHelmetSafety as fasUserHelmetSafety,
  faWifi as fasWifi,
  faXmark as fasXmark,
  faZap as fasZap,
  faRightLeftLarge as fasRightLeftLarge
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
import type { App, Plugin } from 'vue';

export function createIcon(): Plugin {
  return {
    install: (app: App) => {
      library.add(
        // Light
        falNote,
        falAddressCard,
        falApartment,
        falArrowLeft,
        falArrowProgress,
        falBan,
        falBicycle,
        falBox,
        falBuilding,
        falBuildings,
        falCube,
        falCubes,
        falBuildingColumns,
        falBus,
        falCar,
        falCarSideBolt,
        falCartShopping,
        falChargingStation,
        falCircleB,
        falCircleCheck,
        falCircleD,
        falCircleExclamation,
        falCircleI,
        falCircleInfo,
        falCircleL,
        falCircleM,
        falCircleMinus,
        falCircleN,
        falCircleParking,
        falCircleQuestion,
        falCircleR,
        falCircleS,
        falCircleT,
        falCircleW,
        falCircleXmark,
        falCloud,
        falEnvelope,
        falEye,
        falEyeSlash,
        falEthernet,
        falFileInvoiceDollar,
        falFloppyDisk,
        falForkKnife,
        falFutbol,
        falGasPump,
        falGaugeHigh,
        falGlobe,
        falHome,
        falHotel,
        falHourglassEmpty,
        falIdCard,
        falListCheck,
        falLock,
        falMobileSignalOut,
        falMoneyBill1,
        falMugSaucer,
        falPlane,
        falRacquet,
        falShareNodes,
        falSignalStream,
        falSimCard,
        falSitemap,
        falStairs,
        falTaxi,
        falTrain,
        falTrainSubwayTunnel,
        falTrainTram,
        falTree,
        falTrees,
        falUser,
        falWifi,
        falBolt,
        falBoltSlash,
        falTriangleExclamation,
        falWrench,
        falXmark,

        // Regular
        faArrowDown,
        faArrowRightFromBracket,
        faArrowUp,
        faArrowUpToLine,
        faArrowsRotate,
        faChevronDown,
        faChevronUp,
        faChevronsLeft,
        faChevronsRight,
        faCircle,
        faCircleNotch,
        faClock,
        faCopy,
        faCube,
        faEllipsisVertical,
        faFileLines,
        faHashtag,
        faKey,
        faLocationDot,
        faPenToSquare,
        faSpinner,
        faTrash,
        faTrashCan,
        faTurnDownRight,
        faPen,

        // Solid
        fasArrowDownWideShort,
        fasArrowRight,
        fasArrowRotateRight,
        fasArrowsRotate,
        fasArrowUpArrowDown,
        fasBan,
        fasBars,
        fasBatteryBolt,
        fasBoltLightning,
        fasCaretDown,
        fasCaretUp,
        fasChargingStation,
        fasCheck,
        fasCircleCheck,
        fasCircleExclamation,
        fasCircleInfo,
        fasCircleSmall,
        fasCircleXmark,
        fasCodeSimple,
        fasDatabase,
        fasDoorOpen,
        fasFileCsv,
        fasFingerprint,
        fasForward,
        fasGaugeHigh,
        fasGear,
        fasGlobe,
        fasHandshakeAlt,
        fasHandshakeAngle,
        fasHome,
        fasInfo,
        fasLink,
        fasLocationDot,
        fasMagnifyingGlass,
        fasMailbox,
        fasMoneyBillTransfer,
        fasPercent,
        fasPlay,
        fasPlug,
        fasPlus,
        fasPowerOff,
        fasRefresh,
        fasRepeat,
        fasReplyAll,
        fasRotateRight,
        fasScrewDriverWrench,
        fasSendBack,
        fasShuffle,
        fasSignal,
        fasSlidersSimple,
        fasSort,
        fasSolarPanel,
        fasStop,
        fasTemperatureThreeQuarters,
        fasTimer,
        fasTrash,
        fasUnlock,
        fasUpload,
        fasUser,
        fasUserHelmetSafety,
        fasWifi,
        fasXmark,
        fasZap,
        fasRightLeftLarge,

        // Duo-tone
        fadSortDown,
        fadSortUp,
        fadSignalWeak,
        fadSignalFair,
        fadSignalGood,
        fadSignalStrong,
        fadSignalPerfect
      );

      app.component('font-awesome-icon', FontAwesomeIcon);
      app.component('font-awesome-layers', FontAwesomeLayers);
    }
  };
}
